import { useState } from "react";
import CustomButton from "../../../helperComponents/CustomButton";
import { serverLine } from "../../../../controllers/network/serverLine";
import contentCardButtonStyle from "../../../../data/contentCardButtonStyle";
import { TiTick } from "react-icons/ti";
import { LiaHandsHelpingSolid } from "react-icons/lia";
import { MdDone } from "react-icons/md";

export default function VolunteerButton({ status, contentId, count }) {
  const [volStatus, setVolStatus] = useState(status);
  const [theCount, setTheCount] = useState(count ? count : 0);

  let theStyle = { ...contentCardButtonStyle };

  if (volStatus) {
    theStyle.background = "var(--accentDim)";
  }

  return (
    <CustomButton
      style={theStyle}
      onClick={doIt}
      icon={volStatus ? <MdDone /> : <LiaHandsHelpingSolid />}
    >
      {volStatus ? "Volunteered" : "Volunteer"} {theCount}
    </CustomButton>
  );

  function doIt() {
    if (volStatus) {
      setTheCount(theCount - 1);
    } else {
      setTheCount(theCount + 1);
    }
    setVolStatus(!volStatus);
    serverLine.post("/volunteer", {
      contentId: contentId,
      action: volStatus ? "REMOVE" : "ADD",
    });
  }
}
